import moment from 'moment'
import React from 'react'
import { Button } from 'reactstrap'
import { request } from '../../../Redux/Sagas/requests/api'
import { isSuccessResponse } from '../../../helper'
import { useDispatch } from 'react-redux'
import { setCurrentRow, setParentTableData } from '../../../Redux/Reducers/CMS'

const EmailGrid = ({
  data,
  source_table,
  current_row_id,
  parent_table,
  gridSelectedRow,
  updategridSelectedRow,
  gridRelatedData,
  triggerButtonActions,
}) => {
  const dispatch = useDispatch()
  const content = gridRelatedData?.tableGrid
  const onDelete = (id) => {
    let data = {
      source_table: source_table,
      ids: [id],
      parent_table_row_id: current_row_id,
      parent_table: parent_table[0]?.source_table,
    }
    request('connect-template-delete', 'POST', data).then((res) => {
      isSuccessResponse(res, 'Email deleted successfully')
    })
  }

  const onEdit = (item) => {
    const apiData = item
    dispatch(setCurrentRow(item))
    dispatch(
      setParentTableData({
        source_table: content?.source_table,
        parent_page_name: content?.name,
        grid_id: content?.main_grid?.id,
        child_table: content?.child_tabs?.component_call_buttons[0]?.source_table,
      })
    )

    triggerButtonActions(
      [
        {
          component_type: 'actions',
          component_name: 'open_tab',
          slug: '',
          url: '/{id}',
          post_data: null,
        },
      ],
      [],
      apiData
    )
  }
  const onCheck = (item) => {
    const gridSelectedRowIds = gridSelectedRow.map((row) => row?.original?.id)
    if (gridSelectedRowIds.includes(item?.id)) {
      const index = gridSelectedRowIds.indexOf(item?.id)
      const selectedRows = [...gridSelectedRow]
      selectedRows.splice(index, 1)
      updategridSelectedRow(selectedRows)
    } else {
      updategridSelectedRow([...gridSelectedRow, { original: item }])
    }
  }
  return (
    <div className='table-responsive'>
      <table className='table table-bordered' style={{ borderColor: '#EAEAEA' }}>
        {/* <thead>
          <tr>
            <th style={{ width: '5rem' }}>Column 1</th>
            <th style={{ width: '5rem' }}>Column 2</th>
            <th>Column 3</th>
          </tr>
        </thead> */}
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              <td style={{ borderColor: '#EAEAEA', width: '2rem' }}>
                <input
                  type='checkbox'
                  onChange={() => {
                    onCheck(row)
                  }}
                />
              </td>
              <td style={{ borderColor: '#EAEAEA', width: '3rem' }}>
                <div className='d-flex flex-column align-items-center'>
                  <Button color='primary' size='sm' onClick={() => onEdit(row)} disabled={row?.sent}>
                    <i className='far fa-edit'></i>
                  </Button>
                  <Button color='danger' className='mt-2' size='sm' disabled={row?.sent} onClick={() => onDelete(row?.id)}>
                    <i className='pe-7s-trash'></i>
                  </Button>
                </div>
              </td>
              <td style={{ borderColor: '#EAEAEA' }}>
                <div>
                  <div className='d-flex justify-content-between align-items-center flex-wrap'>
                    <div className='body2  font-weight-bold mb-1'>{row?.title}</div>
                    <div className='d-flex align-items-center flex-wrap mb-1' style={{ gap: '0.35rem' }}>
                      {Number(row?.approve) === 1 ? (
                        <span className='badge badge-pill badge-info p-2'>Approved</span>
                      ) : (
                        <span className='badge badge-pill badge-secondary p-2'>Not approved</span>
                      )}
                      {row?.sent ? (
                        <span className='badge badge-pill badge-success p-2'>Sent</span>
                      ) : (
                        <span className='badge badge-pill badge-danger p-2'>Not Sent</span>
                      )}
                    </div>
                  </div>

                  <div className='subtitle1 font-italic mb-3'>
                    Send on {moment.utc(row?.send_renewal_email_date).format('Do, MMM YYYY')}{' '}
                    {row?.send_after_label && <span>( After {parseInt(row?.send_after_label)} days)</span>}
                  </div>
                  <div className='subtitle1' dangerouslySetInnerHTML={{ __html: row?.message }}></div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default EmailGrid
